import React from 'react';
import { Box, Typography } from '@mui/material';
import { useParams } from 'react-router';

const CampaignHierarchyTree = ({ treeData }) => {
  const { campaignId } = useParams();
  if (!treeData) return null;

  const renderGraph = (root) => {
    const levelHeight = 140;
    const nodeRadius = 40;
    const nodeWidth = 160;
    const positions = {};
    const links: any = [];
    let yLevels: any = [];

    const traverse = (node, depth = 0, parentId = null) => {
      if (!yLevels[depth]) yLevels[depth] = 0;

      const x = 100 + yLevels[depth] * nodeWidth;
      const y = 60 + depth * levelHeight;

      positions[node.campaign_id] = { x, y, name: node.campaign_name };

      if (parentId) links.push({ from: parentId, to: node.campaign_id });

      yLevels[depth]++;
      node.children?.forEach((child) => traverse(child, depth + 1, node.campaign_id));
    };

    traverse(root);

    const getColor = (id) => {
      if (id === root.campaign_id) return '#9c27b0';
      if (id === campaignId) return '#2196f3';
      return '#4caf50';
    };

    const lines = links.map((link, idx) => {
      const from = positions[link.from];
      const to = positions[link.to];
      return (
        <line key={idx} x1={from.x} y1={from.y + nodeRadius} x2={to.x} y2={to.y - nodeRadius} stroke="#000" />
      );
    });

    const nodes = Object.entries(positions).map(([id, { x, y, name }]) => (
      <g key={id}>
        <circle cx={x} cy={y} r={nodeRadius} fill={getColor(id)} />
        <text x={x} y={y} textAnchor="middle" dy="0.35em" fontWeight="bold" fill="black" style={{ fontSize: '12px' }}>
          {name.length > 12 ? name.slice(0, 10) + '…' : name}
        </text>
      </g>
    ));

    const svgHeight = (yLevels.length + 1) * levelHeight;
    return <svg width="100%" height={svgHeight}>{lines}{nodes}</svg>;
  };

  return (
    <Box mt={3} p={2} border="1px dashed #ccc" borderRadius="8px" overflow="auto" >
      <Typography variant="h6" align="center" mb={2}>
        Tree View of {treeData?.campaign_name || ''}
      </Typography>
      <Box sx={{ display: "flex", justifyContent: "center", overflow: "auto" }}>
        <Box sx={{ width: 'fit-content' }}>
          {renderGraph(treeData)}
        </Box>
      </Box>
    </Box>
  );
};

export default CampaignHierarchyTree;
